/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure, withHandlers } from 'recompose';
import _ from 'lodash';
import { Row, Col } from 'reactstrap';
import cx from 'classnames';

import StepGroup from '../StepGroup';
import { actions } from '../../actions/design';
import { branch } from '../../utils';

import {
  getActive,
  getErrors,
  getCompleteCount,
  getStepList,
  getStatus,
  getDesignLoading,
} from '../../selectors/progress';

import type { StateType } from '../../actions/progress';

import classes from './StepProgressBar.scss';

type PropsType = {
  active: string,
  calculateGroupOffset: Function,
  getGroupIndex: Function,
  hasError: boolean,
  onJumpStep: typeof actions.jumpStep,
  onStepGroupClick: Function,
  stepGroupStatus: {},
  stepList: string[],
  successWidth: number,
};

const defaultProps = {};

const config = {
  SVG_WIDTH: 100,
  BASE_HEIGHT: 50,
  TEXT_HEIGHT: 20,
  get RECT_HEIGHT() {
    return this.BASE_HEIGHT / 2.5;
  },
  get SVG_OFFSET() {
    return 100 - this.SVG_WIDTH;
  },
};

export class StepProgressBar extends React.PureComponent<PropsType, *> {
  static defaultProps = defaultProps;
  props: PropsType;

  render() {
    const {
      hasError,
      successWidth,
      stepList,
      stepGroupStatus,
    } = this.props;

    const stepGroups = _.map(
      stepList,
      (step: any) => (
        <StepGroup
          key={step}
          id={step}
          config={config}
          onClickHandler={this.props.onStepGroupClick}
          calcOffset={this.props.calculateGroupOffset}
          getIndex={this.props.getGroupIndex}
          active={this.props.active === step}
          status={stepGroupStatus[step]}
        />
      ),
    );

    const errorRail = (
      <rect
        className={cx(classes.rail, classes.errorRail)}
        y={((config.BASE_HEIGHT / 2) - (config.RECT_HEIGHT / 2)) + 1}
        rx={config.RECT_HEIGHT / 2}
        ry={config.RECT_HEIGHT / 2}
        height={config.RECT_HEIGHT}
        width="100%"
      />
    );

    return (
      <Row noGutters className={classes.navWrapper}>
        <Col>
          <svg
            className={classes.rootSvg}
            height={`${config.BASE_HEIGHT + config.TEXT_HEIGHT}`}
            width="100%"
            id="svgProgressNav"
          >
            <defs>
              <pattern
                id="pattern-stripe"
                width="50"
                height="4"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(45)"
              >
                <rect width="25" height="4" transform="translate(0,0)" fill="rgba(255, 0, 0, 80)" />
              </pattern>
              <mask id="mask-stripe">
                <rect x="0" y="0" width="100%" height="100%" fill="url(#pattern-stripe)" />
              </mask>
            </defs>
            <g>
              <rect
                className={cx(
                  classes.rail,
                  classes.backgroundRail,
                )}
                x="0"
                y={((config.BASE_HEIGHT / 2) - (config.RECT_HEIGHT / 2)) + 1}
                rx={config.RECT_HEIGHT / 2}
                ry={config.RECT_HEIGHT / 2}
                height={config.RECT_HEIGHT}
                width="100%"
              />

              { branch(hasError, errorRail, null) }

              <rect
                className={cx(
                  classes.rail,
                  classes.widthTransition,
                  classes.completeRail,
                )}
                x="0"
                y={((config.BASE_HEIGHT / 2) - (config.RECT_HEIGHT / 2)) + 1}
                rx={config.RECT_HEIGHT / 2}
                ry={config.RECT_HEIGHT / 2}
                height={config.RECT_HEIGHT}
                width={`${successWidth}%`}
              />
              <rect
                x="0"
                y={((config.BASE_HEIGHT / 2) - (config.RECT_HEIGHT / 2)) + 1}
                rx={config.RECT_HEIGHT / 2}
                ry={config.RECT_HEIGHT / 2}
                height={config.RECT_HEIGHT}
                width="100%"
                fill="black"
                style={{ mask: 'url(#mask-stripe)' }}
              />
            </g>
            <g>{stepGroups}</g>
          </svg>

        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state: StateType) {
  // const stepStatus = getStatus(state);
  const stepList = getStepList(state);
  const active = getActive(state);
  const loading = getDesignLoading(state);
  const errors = getErrors(state);
  const completeCount = getCompleteCount(state);
  const stepGroupStatus = getStatus(state);

  const len = _.size(stepList) + 1;
  const adjustedCount = completeCount + 1;

  const calcSuccessWidth = () => {
    if (adjustedCount === (len - 1)) return 100;
    return (100 / len) * adjustedCount;
  };

  return {
    active,
    loading,
    stepList,
    stepGroupStatus,
    successWidth: calcSuccessWidth(),
    hasError: _.size(errors) > 0,
  };
}

const enhancer = compose(
  connect(mapStateToProps),
  pure,
  withHandlers({
    onJumpStep: props => (payload: string) => props.dispatch(actions.jumpStep(payload)),
    get onStepGroupClick() {
      return (props: PropsType) => (id: string) => {
        if (props.loading) return;
        if (props.active !== id) this.onJumpStep(props)(id);
      };
    },
    getGroupIndex: props => (id: string) => props.stepList.findIndex(i => i === id) + 1,
    calculateGroupOffset: props => (id: string) => {
      const index = props.stepList.findIndex(i => i === id);
      return (100 / (_.size(props.stepList) + 1)) * (index + 1);
    },
  }),
);

export default enhancer(StepProgressBar);



// WEBPACK FOOTER //
// ./src/components/StepProgressBar/StepProgressBar.js